import { ResetPasswordForm } from 'components/Forms/Auth/ResetPassword';
import { AuthLayout } from 'components/Layout/Auth';
import { addApolloState, initializeApollo } from 'lib/clients/apolloClient';
import { GLOBAL } from 'queries';

const ResetPassword = () => {
  return <ResetPasswordForm />;
};

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await Promise.all([
    apolloClient.query({
      query: GLOBAL,
    }),
  ]);

  return addApolloState(apolloClient, {
    props: {},
    revalidate: 60 * 5,
  });
}

ResetPassword.Layout = AuthLayout;

export default ResetPassword;
